// Kanonische Sidebar-Struktur für den Einstellungs-Editor
// (Menü & Navigation). Die Keys müssen exakt mit den hrefs/Gruppen-IDs
// in DashboardLayout.js übereinstimmen.
//  - Top-Level-Items: key = href
//  - Gruppen: key = 'group:<id>', Kinder-Keys = href
// Reine Admin-relevante Einträge (Superadmin-/Technik-Einträge bleiben fix).

export const SIDEBAR_NAV_CONFIG = [
  { key: '/', name: 'Dashboard' },
  { key: '/customers', name: 'Kunden' },
  { key: '/appointments', name: 'Termine' },
  { key: '/waitlist', name: 'Warteliste' },
  { key: '/resources', name: 'Ressourcen' },
  { key: '/courses-admin', name: 'Kurse' },
  { key: '/whatsapp', name: 'WhatsApp Chat' },
  { key: '/dental', name: 'Zahnschema' },
  { key: '/dental-perio', name: 'PA-Befund' },
  { key: '/dental-recall', name: 'Dental Recall' },
  { key: '/dental-billing', name: 'Dental Abrechnung' },
  { key: '/dental-estimates', name: 'Kostenvoranschlag' },
  { key: '/dental-plans', name: 'Behandlungsplan' },
  { key: '/workshop', name: 'Werkstatt' },
  {
    key: 'group:training', name: 'Training & Ernährung', group: true, children: [
      { key: '/training', name: 'Training' },
      { key: '/wod-training', name: 'WOD Pläne' },
      { key: '/nutrition', name: 'Ernährung' },
      { key: '/admin/recipes', name: 'Rezept-Katalog' },
      { key: '/health-dashboard', name: 'Gesundheit' },
      { key: '/product-reviews', name: 'Nährwert-Reviews' },
    ],
  },
  {
    key: 'group:finanzen', name: 'Finanzen', group: true, children: [
      { key: '/customer-subscriptions', name: 'Kunden-Abos' },
      { key: '/sales', name: 'Verkaufen' },
      { key: '/discounts', name: 'Rabattcodes' },
      { key: '/invoices', name: 'Alle Rechnungen' },
      { key: '/billing', name: 'Offene Abrechnungen' },
      { key: '/billing-audit', name: 'Abrechnungs-Kontrolle' },
      { key: '/payments', name: 'Zahlungen' },
      { key: '/rent-invoices', name: 'Miet-Rechnungen' },
      { key: '/cards-overview', name: 'Hinterlegte Karten' },
      { key: '/physio-billing', name: 'Physio-Abrechnung' },
    ],
  },
  {
    key: 'group:marketing', name: 'Marketing & Analyse', group: true, children: [
      { key: '/crm', name: 'CRM / Leads' },
      { key: '/campaigns', name: 'Marketing' },
      { key: '/admin/ads', name: 'Werbung (Ads)' },
      { key: '/admin/loyalty', name: 'Treue-Rabatt' },
      { key: '/message-log', name: 'Versand-Protokoll' },
      { key: '/communication-log', name: 'Kommunikations-Protokoll' },
      { key: '/website-analytics', name: 'Website Analytics' },
      { key: '/funnel-tracking', name: 'Funnel-Tracking' },
      { key: '/reports', name: 'Berichte' },
      { key: '/feedback-analytics', name: 'Bewertungen' },
    ],
  },
  {
    key: 'group:personal', name: 'Personal', group: true, children: [
      { key: '/personal', name: 'Mitarbeiter' },
      { key: '/personal?tab=stunden', name: 'Stundenerfassung' },
      { key: '/personal?tab=lohn', name: 'Lohn & AHV' },
    ],
  },
  {
    key: 'group:system', name: 'System', group: true, children: [
      { key: '/global-history', name: 'Globale History' },
      { key: '/mobile-app', name: 'Mobile App' },
      { key: '/admin/deleted-accounts', name: 'Gelöschte Konten' },
      { key: '/admin/vendor-credentials', name: 'Bestell-Logins' },
      { key: '/audit-log', name: 'Audit-Log' },
    ],
  },
  { key: '/mein-abo', name: 'Mein Abo' },
  { key: '/meine-rechnungen', name: 'Meine Rechnungen' },
  { key: '/settings', name: 'Einstellungen' },
];

// Standard-Reihenfolge der Top-Level-Keys (inkl. Superadmin, fix an Position 0)
export const DEFAULT_TOP_ORDER = [
  '/superadmin',
  ...SIDEBAR_NAV_CONFIG.map((b) => b.key),
];

export const groupIdOf = (key) => (key || '').replace('group:', '');
